export default "__VITE_ASSET__BlCcAe3S__"